import { paletteTheme } from "@configs/theme/custom/palette";

export const paginationTheme = {
  lineType: "none",
  itemActiveBg: "transparent",
  itemSize: 20,
  colorPrimary: paletteTheme.colorPrimary,
};
